import {
  BrowserCacheLocation,
  LogLevel,
  PublicClientApplication
} from '@azure/msal-browser';

const clientId = process.env.REACT_APP_MSAL_CLIENT_ID || '';
const knownAuthority = process.env.REACT_APP_MSAL_KNOWN_AUTHORITY || '';
const signUpSignInAuthority =
  process.env.REACT_APP_MSAL_AUTHORITY_SIGNUP_SIGNIN || '';
const postLoginRedirectUri =
  process.env.REACT_APP_MSAL_POST_LOGIN_REDIRECT_URI || '';
const postLogoutRedirectUri =
  process.env.REACT_APP_MSAL_POST_LOGOUT_REDIRECT_URI || '';
const postChangePasswordRedirectUri =
  process.env.REACT_APP_MSAL_POST_CHANGE_PASSWORD_REDIRECT_URI || '';
const passwordChangeAuthority =
  process.env.REACT_APP_MSAL_AUTHORITY_PASSWORD_CHANGE || '';

const config = {
  clientId,
  knownAuthority,
  signUpSignInAuthority,
  postLoginRedirectUri,
  postLogoutRedirectUri,
  postChangePasswordRedirectUri,
  passwordChangeAuthority
};

const msalConfig = {
  auth: {
    clientId: config.clientId,
    authority: config.signUpSignInAuthority,
    knownAuthorities: [config.knownAuthority],
    navigateToLoginRequestUrl: true,
    redirectUri: config.postLoginRedirectUri,
    postLogoutRedirectUri: config.postLogoutRedirectUri
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage, // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
    storeAuthStateInCookie: false // If you wish to store cache items in cookies as well as browser cache, set this to "true".
  },
  system:
    process.env.NODE_ENV !== 'production'
      ? {
          loggerOptions: {
            loggerCallback: (level: LogLevel, message: string): void => {
              console.log(message);
            }
          }
        }
      : {}
};

const msalInstance = new PublicClientApplication(msalConfig);

const msalLogout = async () => {
  const account = msalInstance.getAllAccounts()[0];
  await msalInstance.logoutRedirect({
    account,
    postLogoutRedirectUri: config.postLogoutRedirectUri
  });
};

export { msalInstance, msalLogout, config };
